// extracted by mini-css-extract-plugin
export default {"brands":"Brands_brands__dQdAT","wrapper":"Brands_wrapper__a5BLs"};